import { render, staticRenderFns } from "./InspectionCriteria3.vue?vue&type=template&id=66e599a1&scoped=true"
import script from "./InspectionCriteria3.vue?vue&type=script&lang=ts"
export * from "./InspectionCriteria3.vue?vue&type=script&lang=ts"
import style0 from "./InspectionCriteria3.vue?vue&type=style&index=0&id=66e599a1&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66e599a1",
  null
  
)

export default component.exports